import { createActionsHook, createHook, createStore, type StoreActionApi } from 'react-sweet-state';

const SINGLE_COLUMN_BREAKPOINT = 768;
const NARROW_BREAKPOINT = 960;

type LayoutStoreState = {
	containerWidth: number | null;
};

const initialState: LayoutStoreState = {
	containerWidth: null,
};

const actions = {
	setContainerWidth:
		(containerWidth: number) =>
		({ setState }: StoreActionApi<LayoutStoreState>) => {
			setState({ containerWidth });
		},
} as const;

type Actions = typeof actions;

const LayoutStore = createStore<LayoutStoreState, Actions>({
	initialState,
	actions,
	name: 'LayoutStore',
});

const useLayoutStoreInner = createHook(LayoutStore);

const useIsSingleColumnInner = createHook(LayoutStore, {
	selector: (state) => !!(state.containerWidth && state.containerWidth < SINGLE_COLUMN_BREAKPOINT),
});

const useIsNarrowInner = createHook(LayoutStore, {
	selector: (state) => !!(state.containerWidth && state.containerWidth < NARROW_BREAKPOINT),
});

export const useLayoutStore = () => useLayoutStoreInner()[0];
export const useLayoutStoreActions = createActionsHook(LayoutStore);
export const useIsSingleColumn = () => useIsSingleColumnInner()[0];
export const useIsLayoutNarrow = () => useIsNarrowInner()[0];
